export const RESULTS = '/results';
export const RESULTS_INSURANCE_DETAILS = '/insurance-details';
